module.exports = __webpack_public_path__ + "static/media/tuer_richtig.d3406286.jpg";